export enum RoutePaths {
    GAMES_HOME_ROUTE= "/games",
    FILMS_HOME_ROUTE= "/films",
    ALL_GAMES_SUB_ROUTE = "/games/all",
    TODO_SUB_ROUTE = "/todo",
    LISTS_ROUTE = "/lists",
    CINEMA_ROUTE = "/cc"
}